import SummaryType from "state/selections/Constants/SummaryType";

export default class FactorAttributionDefinition {
  static getDefault = () =>
    new FactorAttributionDefinition({
      summary: SummaryType.ABSOLUTE,
      factribFactor: "TOTAL",
      factribPeriod: "YTD",
    });

  #factribFactor;
  #factribPeriod;
  #factribAsOfDate;
  #summary;

  constructor(props = {}) {
    const { factribFactor, factribPeriod, factribAsOfDate, summary } = props;

    this.#factribFactor = factribFactor;
    this.#factribPeriod = factribPeriod;
    this.#factribAsOfDate = factribAsOfDate;
    this.#summary = summary;
  }

  get factribFactor() {
    return this.#factribFactor;
  }
  get factribPeriod() {
    return this.#factribPeriod;
  }
  get factribAsOfDate() {
    return this.#factribAsOfDate;
  }
  get summary() {
    return this.#summary;
  }
  get key() {
    return `Factor Attrib - ${this.factribFactor}, ${this.factribPeriod}, ${
      this.summary
    }, ${this.factribAsOfDate ?? ""}`;
  }

  get complete() {
    return this.factribFactor?.length && this.factribPeriod?.length;
  }

  copy = () => {
    return {
      factribFactor: this.factribFactor,
      factribPeriod: this.factribPeriod,
      factribAsOfDate: this.factribAsOfDate,
      summary: this.summary,
    };
  };
  setFactribFactor = (value) =>
    new FactorAttributionDefinition({
      ...this.copy(),
      factribFactor: value,
    });
  setFactribPeriod = (value) =>
    new FactorAttributionDefinition({
      ...this.copy(),
      factribPeriod: value,
    });
  setFactribAsOfDate = (value) =>
    new FactorAttributionDefinition({
      ...this.copy(),
      factribAsOfDate: value,
    });
  setSummary = (value) =>
    new FactorAttributionDefinition({
      ...this.copy(),
      summary: value,
    });
}
